import makeStyles from "@mui/styles/makeStyles";

export const assetStyles = (theme) => ({
    contentContainer: {
        padding: 0,
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    container: {
        flex: 1,
    },
    cancelButton: {
        marginLeft: 20,
    },
    whiteColor: {
        backgroundColor: "#fff",
    },
    dropZoneStyle: {
        outline: "none",
    },
    tabContainer: {
        minHeight: 250,
        outline: "none",
    },
    image: {
        height: 300,
        width: 300,
        
        borderStyle: "solid",
        borderWidth: 0,
        borderColor: "#444444ad",
    },
    imageContainer: {
        height: 300,
        width: 300,
        margin: "auto",
        marginTop: 20,
        borderStyle: "dashed",
        borderWidth: 0,
        borderColor: "#999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    dragContainer: {
        borderWidth: 2,
        borderRadius: 2,
        borderColor: theme.palette.primary.blackOpacity5,
        borderStyle: "dashed",
        minHeight: 200,
        marginTop: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    globalDrag: {
        display: "none",
        top: 0,
        bottom: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(79, 65, 159, 0.6)",
        color: theme.palette.primary.opacityText9,
        position: "absolute",
        fontSize: 35,
        fontWeight: 900,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
    },
    dragContainerAccept: {
        borderColor: theme.palette.success.main,
    },
    dragContainerRejected: {
        borderColor: theme.palette.error.main,
    },
    dragContainerActive: {
        borderColor: theme.palette.primary.light,
    },
});
export const useSelectIconStyles = makeStyles(assetStyles);

export const useTabSectionStyles = makeStyles({
    container: {
        flex: 1,
        backgroundColor: "#eeeeee",
    },
});

export const useFileUploadStyles = makeStyles({
    container: {
        width: "100%",
        "& > img": {
            width: "100%",
        },
    },
    progressContainer: {
        width: "100%",
        "& > div": {
            height: 10,
        },
    },
});
